import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "search-open-close-button-expansion-bar"
}

interface Props {
  display: boolean;
  open: boolean | true;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchOpenCloseButton',
  props: {
    display: { type: Boolean },
    open: { type: Boolean }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const openClose = () => {
  let opened = props.open;
  if (opened) {
    opened = false;
  } else {
    opened = true;
  }
  emit('open', opened);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.display)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_btn, {
          color: "primary",
          flat: "",
          class: "full-width",
          onClick: openClose
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              left: "",
              name: _ctx.open ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down'
            }, null, 8, ["name"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})